<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item label="检验类型">
              <span>{{ formatInspectionType(formData.inspectionType) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品规格">
              <span>{{ formData.specName || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产日期">
              <span>{{ formData.productionDate || '--' }}</span>
            </el-form-item>
          </el-col>
        <el-col :span="12">
          <el-form-item label="保质期(月)">
            <span>{{ formData.shelfLifeMonth || '--' }}</span>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="保质期至">
              <span>{{ formData.shelfLifeEndDate || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产线">
              <span>{{ formData.productionLine || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标签是否正常">
              <el-tag type="success" v-if="formData.labelCorrect === '1'">正常</el-tag>
              <el-tag type="danger" v-if="formData.labelCorrect === '2'">异常</el-tag>
              <span v-if="!formData.labelCorrect">--</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="喷码是否正常">
              <el-tag type="success" v-if="formData.sprayCodeCorrect === '1'">正常</el-tag>
              <el-tag type="danger" v-if="formData.sprayCodeCorrect === '2'">异常</el-tag>
              <span v-if="!formData.sprayCodeCorrect">--</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="压盖是否完好">
              <el-tag type="success" v-if="formData.capIntact === '1'">正常</el-tag>
              <el-tag type="danger" v-if="formData.capIntact === '2'">异常</el-tag>
              <span v-if="!formData.capIntact">--</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="瓶内是否有杂质">
              <el-tag type="success" v-if="formData.bottleImpurity === '1'">正常</el-tag>
              <el-tag type="danger" v-if="formData.bottleImpurity === '2'">异常</el-tag>
              <span v-if="!formData.bottleImpurity">--</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="瓶外壁是否完好">
              <el-tag type="success" v-if="formData.bottleWallIntact === '1'">正常</el-tag>
              <el-tag type="danger" v-if="formData.bottleWallIntact === '2'">异常</el-tag>
              <span v-if="!formData.bottleWallIntact">--</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <span>{{ formData.remark || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="创建人">
              <span>{{ formData.createUserName || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              <span>{{ formData.ctime || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="复核状态">
              <template v-if="formData.inspectionType === '1'">
                <el-tag type="warning" v-if="formData.reviewStatus === '1'">待复核</el-tag>
                <el-tag type="success" v-if="formData.reviewStatus === '2'">已复核</el-tag>
              </template>
              <span v-else>--</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="复核人">
              <span>{{ formData.reviewUserName || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="复核时间">
              <span>{{ formData.reviewTime || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件">
              <file-upload view-type="img" readonly action="" v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'productionProcessDetail',
  data() {
    return {
      formData: {
        productionDate: '',
        inspectionType: '',
        specId: '',
        specName: '',
        shelfLifeMonth: null,
        shelfLifeEndDate: '',
        productionLine: '',
        labelCorrect: '',
        sprayCodeCorrect: '',
        capIntact: '',
        bottleImpurity: '',
        bottleWallIntact: '',
        remark: '',
        fileList: [],
        reviewStatus: '1',
        reviewTime: '',
        reviewUserName: '',
        createUserName: '',
        ctime: ''
      },
      loading: false,
      specList: []
    }
  },
  created() {
    if (this.checkId) {
      this.loadData()
    }
  },
  computed: {
    checkId() {
      return this.$route.query.checkId
    }
  },
  methods: {
    formatInspectionType(inspectionType) {
      if (inspectionType === '1') {
        return '生产过程首件检验'
      }
      if (inspectionType === '2') {
        return '生产过程关键控制点'
      }
      return '--'
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.productionProcess.selectPaProductionInspectionByCheckId, {
          params: { checkId: this.checkId }
        })
        .then(res => {
          res.fileList = res.fileList || []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}
::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
.empty {
  font-size: 14px;
  color: #999;
}
.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;
}
</style>
